import React from 'react';
import Header from './../../../component/common/LeaveHeader';
import AddHoliday from '../../../component/holiday/Add';
import Loader from './../../../component/common/Loader';

import CONSTANT from './../../../constant';
import { addHoliday } from './../../../actions/MasterAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.home;
    }

    render() {
        const { showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Holiday detail</h1>
                            </div>
                        </div>
                        <AddHoliday
                            onSubmit={this.onSubmit}
                            onCancel={this.onCancel}
                        />
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onSubmit = (model: any) => {
        this.setState({ showLoader: true });
        addHoliday(model).then((res: any) => {
            this.setState({ showLoader: false });
            if (res) {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    alert('record added successfully');
                    this.props.history.push(CONSTANT.component.adminHolidayList.url);
                } else {
                    alert(res.error);
                }
            }
        });
    }

    onCancel = () => {
        this.props.history.push(CONSTANT.component.adminHolidayList.url);
    }
}

export default ComponentName;